export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
	var timeout;

    $('.woocommerce').on('change', 'input.qty', function(){
 
        if ( timeout !== undefined ) {
            clearTimeout( timeout );
        }
 
        timeout = setTimeout(function() {
            $('[name="update_cart"]').trigger('click');
        }, 1000 );
 
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js